/**
 * @generated SignedSource<<776d33c832234418cb36043fd27bf409>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionsWatchLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionsWatch_user">;
  readonly " $fragmentType": "PdpSharedAuctionsWatchLazy_user";
};
export type PdpSharedAuctionsWatchLazy_user$key = {
  readonly " $data"?: PdpSharedAuctionsWatchLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionsWatchLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionsWatchLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionsWatch_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f636ffcb8e635a8b7416090eda3f0232";

export default node;
